module.exports = __webpack_public_path__ + "static/media/reality-effect.31b7e4b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/afc/reality-effect.mp3
// module id = MtQz
// module chunks = 0